import React, { Component } from 'react';
import './Lightingschedule.css';

class Lightingschedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []

    }
  }

  // handleUserInput = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   this.props.onOptionsUpdate({
  //     [name]: parseInt(value)
  //   });
  // }

  handleUserInput = (e) => {
    let update ={}; //11-01-18
  
    const set = name => {
      const value = e.target.value;
      update[name] = parseInt(value)
    }
      const name = e.target.name;
      set(name) 
      //restrict user 11-01-18
      if(e.target.type === 'number') {
        const min = parseInt(e.target.getAttribute('min'));
        const max = parseInt(e.target.getAttribute('max'));
        const value = parseInt(e.target.value);
        console.log(min, max, value);
        
        if (value < min || value > max) return false;
      }  //end restrict 11-01-18
      this.props.onOptionsUpdate(update);
    }

  render() {
    return (
      <div>
        <p className="calendar_para"><i class="fas fa-lightbulb green-icon"></i> <b>Lighting Number Days per Month and Hours per Day</b></p>
         <table className="tbl_calendardata">
         <tr>
              <th>Jan</th>
              <th>Feb</th>
              <th>Mar</th>
              <th>Apr</th>
              <th>May</th>
              <th>Jun</th>
              <th>Jul</th>
              <th>Aug</th>
              <th>Sep</th>
              <th>Oct</th>
              <th>Nov</th>
              <th>Dec</th>
            </tr>
            <tr>
              <td> <label className="App-bold" htmlfor="janLightingCalendar">days:</label>
                <input type="number"
                  name="janLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.janLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlfor="febLightingCalendar">days:</label>
                <input type="number"
                  name="febLightingCalendar"
                  min="0"
                  max="28"
                  step="1"
                  value={this.props.options.febLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlfor="marLightingCalendar">days:</label>
                <input type="number"
                  name="marLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.marLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td>  <label className="App-bold" htmlfor="mayLightingCalendar">days:</label>
                <input type="number"
                  name="mayLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.mayLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td><label className="App-bold" htmlfor="aprLightingCalendar">days:</label>
                <input type="number"
                  name="aprLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.aprLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlfor="junLightingCalendar">days:</label>
                <input type="number"
                  name="junLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.junLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlfor="julLightingCalendar">days:</label>
                <input type="number"
                  name="julLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.julLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td><label className="App-bold" htmlfor="augLightingCalendar">days:</label>
                <input type="number"
                  name="augLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.augLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlfor="sepLightingCalendar">days:</label>
                <input type="number"
                  name="sepLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.sepLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlfor="octLightingCalendar">days:</label>
                <input type="number"
                  name="octLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.octLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td>  <label className="App-bold" htmlfor="novLightingCalendar">days:</label>
                <input type="number"
                  name="novLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.novLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td>  <label className="App-bold" htmlfor="decLightingCalendar">days:</label>
                <input type="number"
                  name="decLightingCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.decLightingCalendar}
                  onChange={this.handleUserInput}
                /></td>
            </tr>
            <tr>
              <td> <label className="App-bold" htmlfor="janLightingHours">hrs:</label>
                <input type="number"
                  name="janLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.janLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td><label className="App-bold" htmlfor="febLightingHours">hrs:</label>
                <input type="number"
                  name="febLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.febLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlfor="marLightingHours">hrs:</label>
                <input type="number"
                  name="marLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.marLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlfor="aprLightingHours">hrs:</label>
                <input type="number"
                  name="aprLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.aprLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td><label className="App-bold" htmlfor="mayLightingHours">hrs:</label>
                <input type="number"
                  name="mayLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.mayLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlfor="junLightingHours">hrs:</label>
                <input type="number"
                  name="junLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.junLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlfor="julLightingHours">hrs:</label>
                <input type="number"
                  name="julLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.julLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlfor="augLightingHours">hrs:</label>
                <input type="number"
                  name="augLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.augLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlfor="sepLightingHours">hrs:</label>
                <input type="number"
                  name="sepLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.sepLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td><label className="App-bold" htmlfor="octLightingHours">hrs:</label>
                <input type="number"
                  name="octLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.octLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlfor="novLightingHours">hrs:</label>
                <input type="number"
                  name="novLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.novLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td>
                <label className="App-bold" htmlfor="decLightingHours">hrs:</label>
                <input type="number"
                  name="decLightingHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.decLightingHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                />
              </td>
            </tr>
          </table>
       
        
      </div>
    );
  }
}

export default Lightingschedule;


// WEBPACK FOOTER //
// ./src/components/Lightingschedule.js